import PropTypes from 'prop-types';
import {
    Dialog,
    DialogContent,
    DialogActions,
    IconButton,
    Typography,
    Box,
    useTheme,
    useMediaQuery,
    Divider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const Modal = ({
    open,
    onClose,
    title,
    children,
    actions,
    maxWidth = 'md',
    fullWidth = true,
    hideCloseButton = false,
    sx = {},
    containerSx = {},
    middleContent,
    titleStyle,
    closeButtonStyle,
    ...props
}) => {
    const theme = useTheme();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={maxWidth}
            fullWidth={fullWidth}
            PaperProps={{
                sx: {
                    borderRadius: "8px",
                    boxShadow: "none",
                    backgroundColor: "#FFFFFF",
                    ...sx
                },
            }}
            BackdropProps={{
                sx: {
                    backdropFilter: 'blur(5px)',
                    backgroundColor: 'rgba(0, 0, 0, 0.4)',
                },
            }}
            {...props}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: "20px", p: "20px", pt: "15px", ...containerSx }} >
                {title && (
                    <>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: "-5px" }}>
                            <Box sx={titleStyle}>
                                <Typography variant="h6" color={(theme) => theme.palette.primary.main} fontWeight={500}>{title}</Typography>
                            </Box>
                            {middleContent && middleContent}
                            {!hideCloseButton && (
                                <Box sx={closeButtonStyle}>
                                    <IconButton
                                        onClick={onClose}
                                        size="small"
                                        sx={{
                                            color: theme.palette.text.secondary,
                                            '&:hover': {
                                                color: "white",
                                                backgroundColor: theme.palette.action.hover,
                                            },
                                        }}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                            )}
                        </Box>
                        <Divider sx={{ borderColor: "#EEEEEE", }} />
                    </>
                )}
                <DialogContent sx={{ p: 0, '&:last-child': { pb: 0, }, overflow: "visible" }} >
                    {children}
                </DialogContent>
                {actions && (
                    <DialogActions sx={{ justifyContent: 'flex-end', display: "flex", alignSelf: "flex-end", gap: "10px", p: 0, mt: "10px", width: "100%" }}  >
                        {actions}
                    </DialogActions>
                )}
            </Box>
        </Dialog>
    );
};

Modal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string,
    children: PropTypes.node.isRequired,
    actions: PropTypes.node,
    maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    fullWidth: PropTypes.bool,
    hideCloseButton: PropTypes.bool,
};

Modal.defaultProps = {
    maxWidth: 'md',
    fullWidth: true,
    hideCloseButton: false,
};

export default Modal;